module.exports = __webpack_public_path__ + "img/apple-app-store.1f27d630.svg";